import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { withTheme } from 'styled-components';
import Tabs from './Tabs';
import Tab from './Tab';
import { DataStore } from '../stores';

interface ModuleTabsProps {
    theme?: { [property: string]: string | number };
    dataStore?: DataStore;
}

@inject('dataStore')
@observer
class ModuleTabs extends React.Component<ModuleTabsProps> {
    render() {
        const { theme, dataStore } = this.props;
        return (
            <Tabs marginY="lg" {...theme.ModuleTabs}>
                {dataStore.config.modules.map((module, index) => (
                    <Tab
                        key={module.id}
                        onClick={() => dataStore.config.setModule(module)}
                        isSelected={
                            module.id === dataStore.config.selectedModule.id
                        }
                        {...theme.ModuleTab}
                    >
                        {module.label}
                    </Tab>
                ))}
            </Tabs>
        );
    }
}

export default withTheme(ModuleTabs);



// WEBPACK FOOTER //
// ./src/Components/ModuleTabs.tsx